import { SITE_NAME } from '@/shared/lib/config';
import type { NavLink, FooterSection, SocialLink, FooterConfig } from '../types/landing.types';

// Root-relative anchors so the same menu works from the landing, the blog, pSEO and every subpage.
export const NAV_LINKS: NavLink[] = [
  { label: 'Features', href: '/#features' },
  { label: 'Use cases', href: '/#testimonials' },
  { label: 'About', href: '/#about' },
  { label: 'Pricing', href: '/#pricing' },
  { label: 'FAQ', href: '/#faq' },
];

export const NAV_LOGO = '/icons/Minimoes-logo.svg';

export const NAV_ACTIONS = {
  login: { label: 'Log in', href: '/signin' },
  signup: { label: 'Create yours', hoverLabel: "It's free", href: '/signup' },
  dashboard: { label: 'Dashboard', hoverLabel: 'Open dashboard', href: '/dashboard' },
  logout: { label: 'Log out' },
};

export const FOOTER_CONFIG: FooterConfig = {
  headline: 'Give your AI a face.',
  subheadline: 'Free to start.',
  description:
    '3D AI mascots that talk, listen, sell and book on your website, your app and your livestream.',
  newsletterEyebrow: 'Stay updated',
  newsletterDescription: 'New voices, studio updates and release notes.',
  newsletterPlaceholder: 'Your work email',
  newsletterButtonText: 'Subscribe',
  newsletterSuccessText: 'Joined!',
  followLabel: 'Follow us:',
  copyright: `© 2024–${new Date().getFullYear()} ${SITE_NAME}™. All rights reserved.`,
};

export const FOOTER_SECTIONS: FooterSection[] = [
  {
    title: 'Navigation',
    links: [
      { label: 'Home', href: '/' },
      { label: 'Features', href: '/#features' },
      { label: 'Pricing', href: '/#pricing' },
      { label: 'Our Journey', href: '/#about' },
      { label: 'FAQ', href: '/#faq' },
      { label: 'Blog', href: '/blog' },
      { label: 'Updates', href: '/updates' },
    ],
  },
  {
    title: 'By Industry',
    links: [
      { label: 'Real Estate', href: '/ai-avatar/real-estate' },
      { label: 'Healthcare', href: '/ai-avatar/healthcare' },
      { label: 'SaaS & Tech', href: '/ai-avatar/saas' },
      { label: 'E-Commerce', href: '/ai-avatar/ecommerce' },
      { label: 'Finance & Banking', href: '/ai-avatar/finance' },
      { label: 'All industries →', href: '/ai-avatar' },
    ],
  },
  {
    title: 'Use Cases',
    links: [
      { label: 'Customer Service', href: '/ai-avatar/use-case/customer-service' },
      { label: 'Sales Assistant', href: '/ai-avatar/use-case/sales-assistant' },
      { label: 'Lead Generation', href: '/ai-avatar/use-case/lead-generation' },
      { label: 'FAQ Automation', href: '/ai-avatar/use-case/faq-automation' },
      { label: 'Appointment Booking', href: '/ai-avatar/use-case/appointment-booking' },
      { label: 'All use cases →', href: '/ai-avatar/use-case' },
    ],
  },
  {
    title: 'Compare',
    links: [
      { label: 'vs Tavus', href: '/compare/minimoes-vs-tavus' },
      { label: 'vs HeyGen', href: '/compare/minimoes-vs-heygen' },
      { label: 'vs Synthesia', href: '/compare/minimoes-vs-synthesia' },
      { label: 'vs D-ID', href: '/compare/minimoes-vs-d-id' },
      { label: 'vs Convai', href: '/compare/minimoes-vs-convai' },
      { label: 'All comparisons →', href: '/compare' },
    ],
  },
  {
    title: 'Legal & Info',
    links: [
      { label: 'Legal notice', href: '/docs/legal-notice' },
      { label: 'Privacy policy', href: '/docs/privacy-policy' },
      { label: 'Terms of service', href: '/docs/terms' },
      { label: 'Contact us', href: '/contact' },
      { label: 'Get Started →', href: '/signup' },
    ],
  },
];

export const SOCIAL_LINKS: SocialLink[] = [
  { name: 'X / Twitter', href: 'https://x.com/minimoes', icon: 'twitter' },
  { name: 'LinkedIn', href: 'https://linkedin.com/company/minimoes', icon: 'linkedin' },
  { name: 'GitHub', href: 'https://github.com/Minimoes', icon: 'github' },
];
